module.exports = __webpack_public_path__ + "static/media/athinaLogo.ad6924b9.png";